import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';

const Cover = ({ show, close }) => {
    return show ? (
        <div className={styles.wrap}>
            <div className={styles.title} />
            <div className={styles.tv} />
            <div className={styles.screen} />
            <div className={styles.btn} onClick={close} />
            <div className={styles.logo} />
        </div>
    ) : null;
};

Cover.propTypes = {
    show: PropTypes.bool,
    close: PropTypes.func,
};

export default errorBoundary(Cover);
